import firebase from 'firebase/compat/app'
import 'firebase/auth'
import '@firebase/database'
import moment from 'moment'

export default {
  state: {
    loggedInUser:
      localStorage.getItem('userInfo') != null
        ? JSON.parse(localStorage.getItem('userInfo'))
        : null,
    loading: false,
    error: null,
  },
  getters: {
    loggedInUser: (state) => state.loggedInUser,
    // loading: state => state.loading,
    // error: state => state.error,
  },
  mutations: {
    setUser (state, data) {
      console.log("setting user data from authdata", data)
      state.loggedInUser = data
      state.loading = false
      state.error = null
    },
    setLogout (state) {
      state.loggedInUser = null
      state.loading = false
      state.error = null
      state.user = null
      // this.$router.go("/");
    },
    setLoading (state, data) {
      state.loading = data
      state.error = null
    },
    setError (state, data) {
      state.error = data
      state.loggedInUser = null
      state.loading = false
    },
    clearError (state) {
      state.error = null
    },
  },
  actions: {
    autoLogin ({commit, dispatch}, data) {
      dispatch('loadUserInstitutions')
      dispatch('loadunits')
      dispatch('loadsiteProfiles')
      dispatch('loadUserGroups')
      dispatch('loadSiteConfigs')
      dispatch('loadheartbeats')
      if (!firebase.auth().currentUser) {
        console.log('no UID ')
        return
      }
      if (!data) {
        return
      }
      console.log('auto log in with passed with ', data.uid, ' cur ', firebase.auth().currentUser.uid )
      commit('clearError')
      commit('setLoading', true)
      let userId = data.uid
      let userprofile = ''
      firebase.database().ref('users').child(userId).once('value')
        .then(
          (user) => {
            console.log('user profile data ', user.val())
            const newUser = { uid: userId }
            const key = userId
            commit('setUser', { uid: userId, ...user.val() })
            dispatch('loadheartbeats')
            console.log("LOAD USER INST ON AUTOLOGIN")
            if (firebase.auth().currentUser) {
              const actionrecord = {
                user: firebase.auth().currentUser.uid,
                actions: 'signin',
                description: 'login ',
                timestamp: Date.now(),
                meta: 'user',
              }
              const date = moment().format('YYYY-MM-DD')
              firebase
                .database()
                .ref('AUDITLOG')
                .child(date)
                .push(actionrecord)
                .then(() => {
                })
                localStorage.setItem('userInfo', JSON.stringify(newUser))
            }


          })

    },
    login ({ commit, dispatch }, data) {
      commit('clearError')
      commit('setLoading', true)
      firebase
        .auth()
        .signInWithEmailAndPassword(data.email, data.password)
        .then((user) => {
          const newUser = { uid: user.user.uid }
          const key = user.user.uid
          firebase
            .database()
            .ref(`/users/${key}`)
            .update({ lastlogin: Date.now() })
          firebase
            .database()
            .ref('users')
            .child(key)
            .once('value')
            .then((data) => {
              commit('setUser', { uid: user.user.uid, ...data.val() })
              dispatch('loadheartbeats')

              const actionrecord = {
                user: firebase.auth().currentUser.uid,
                actions: 'signin',
                description: 'login ',
                timestamp: Date.now(),
                meta: 'user',
              }
              const date = moment().format('YYYY-MM-DD')
              firebase
                .database()
                .ref('AUDITLOG')
                .child(date)
                .push(actionrecord)
                .then(() => {
                })
            })
          localStorage.setItem('userInfo', JSON.stringify(newUser))
          dispatch('loadheartbeats')
          dispatch('loadUserInstitutions')
          console.log("LOAD USER INST ON REG LOGIN")

          dispatch('loadunits')
          dispatch('loadsiteProfiles')
          dispatch('loadUserGroups')
          dispatch('loadSiteConfigs')
          dispatch('loadheartbeats')
          // commit('setUser', { uid: user.user.uid })
        })
        .catch(function (error) {
          // Handle Errors here.
          // var errorCode = error.code;
          // var errorMessage = error.message;
          localStorage.removeItem('userInfo')
          commit('setError', error)
        })
    },

    signOut ({ commit }) {
      console.log('SIGNOUT FROM AUTH DATA ')
      firebase
        .auth()
        .signOut()
        .then(
          () => {
            localStorage.removeItem('userInfo')
            commit('setLogout')

          },
          (_error) => {},
        )
    },
  },
}
